const data = [
   // { id: "", name: "Todos" }, 
    { id: 0, name: "Pendente" }, 
    { id: 1, name: "Sim" },
    { id: 2, name: "Não" },
    { id: 3, name: "Abstenção" }
]
  
export default [...data]
